import classNames from 'classnames'
import { ElTable } from 'element-plus'
import type { FunctionalComponent } from 'vue'
import './HocElTable.scss'

type ElTableProps = InstanceType<typeof ElTable>['$props']

export const HocElTable: FunctionalComponent<ElTableProps> = (_props, { slots, attrs }) => {
  if (!_props.data || _props.data.length === 0) {
    return (
      <ElTable data={_props.data} {..._props} class={classNames('hoc-el-table', attrs.class as string)}>
        {{
          empty: () => slots.empty?.(),
        }}
      </ElTable>
    )
  }
  return (
    <ElTable {..._props} data={_props.data} class={classNames('hoc-el-table', attrs.class as string)}>
      {slots}
    </ElTable>
  )
}
HocElTable.inheritAttrs = false
